import { defineMessages } from 'react-intl';

/**
 * Message descriptors for ValidateAndUploadFileView. Used with $t to show localized labels and messages.
 */
export const validateAndUploadFileViewMessages = defineMessages({
  fileLabel: {
    id: 'audit.filesUpload.fileLabel',
    defaultMessage: 'Archivo:',
  },
  filesLabel: {
    id: 'audit.filesUpload.filesLabel',
    defaultMessage: 'Archivos:',
  },
  selectFileLabel: {
    id: 'audit.filesUpload.selectFileLabel',
    defaultMessage: 'Seleccionar archivo/s .{type}',
  },
  validateError: {
    id: 'audit.filesUpload.validateError',
    defaultMessage: 'Ocurrió un error al validar el archivo:',
  },
  uploadError: {
    id: 'audit.filesUpload.uploadError',
    defaultMessage: 'Ocurrió un error al subir el archivo:',
  },
  uploading: {
    id: 'audit.filesUpload.uploading',
    defaultMessage: 'Subiendo...',
  },
  uploadFile: {
    id: 'audit.filesUpload.uploadFile',
    defaultMessage: 'Confirmar carga',
  },
  uploadFiles: {
    id: 'audit.filesUpload.uploadFiles',
    defaultMessage: 'Confirmar carga',
  },
  entriesFoundToLoad: {
    id: 'audit.filesUpload.entriesFoundToLoad',
    defaultMessage:
      'Se encontraron {n} entradas {type} para cargar. Confirma la carga o cancela para volver atrás.',
  },
  cancel: {
    id: 'common.cancel',
    defaultMessage: 'Cancelar',
  },
  uploadSuccess: {
    id: 'audit.filesUpload.uploadSuccess',
    defaultMessage: 'Archivo subido exitosamente',
  },
  uploadSuccessMultiple: {
    id: 'audit.filesUpload.uploadSuccessMultiple',
    defaultMessage: 'Archivos subidos exitosamente',
  },
  processNewFile: {
    id: 'validateUpload.processNewFile',
    defaultMessage: 'Procesar nuevo archivo',
  },
});
